var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favicon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 188.7 190.2",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favicon_svg__Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favicon_svg___823292720"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7200.225,
    y1: 8474.855,
    x2: 8628.744,
    y2: 6264.536,
    gradientTransform: "matrix(.072 0 0 .072 -461.787 -401.752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a33150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c53347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7363e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 107.5c8.6 0 15.6 6.9 15.6 15.6 0 .3-.1.6-.1.9 6.2 7.1 9.8 16.3 9.8 26.1 0 22-18.1 40.1-40.1 40.1H40C18 190.1 0 172 0 150c0-10.7 4.3-21 12-28.5L66.5 68c-.2-.9-.3-1.8-.3-2.7 0-8.6 7-15.6 15.6-15.6s15.6 6.9 15.6 15.6c0 8.6-7 15.5-15.6 15.5-1 0-2-.1-3-.3-5.8 5.7-11.5 11.3-17.2 17-7.9 7.8-15.8 15.8-23.3 24-5.1 5.5-11.4 12.3-15.3 18.7-1.7 2.9-2.4 6.4-2.4 9.8 0 10.8 8.8 19.7 19.6 19.7h108.6c10.8 0 19.7-8.9 19.7-19.7 0-3.7-1.7-7.7-4-11.4-.3 0-.5.1-.8.1-8.6 0-15.6-7-15.6-15.6-.2-8.7 6.7-15.6 15.3-15.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#favicon_svg__SVGID_1_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favicon_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 6769.005,
    y1: 7614.024,
    x2: 8297.195,
    y2: 5249.494,
    gradientTransform: "matrix(.072 0 0 .072 -461.787 -401.752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a33150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c53347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7363e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 109.3c1 0 2 .1 3 .3 5.8-5.6 11.4-11.3 17.2-17 7.8-7.8 15.8-15.8 23.3-24 5-5.5 11.3-12.3 15.3-18.7 1.8-3 2.5-6.4 2.5-9.8 0-10.8-8.9-19.7-19.7-19.7H40c-10.8 0-19.6 8.9-19.6 19.7 0 3.7 1.6 7.7 4 11.4h.9c8.6 0 15.6 7 15.6 15.6s-7 15.6-15.6 15.6S9.7 75.6 9.7 67v-.9C3.6 59 0 49.8 0 40 0 18 18 0 40 0h108.6c22 0 40.1 18.1 40.1 40 0 10.8-4.4 21-12 28.6l-54.4 53.5c.1.9.2 1.8.2 2.7 0 8.6-6.9 15.6-15.6 15.6-8.6 0-15.6-7-15.6-15.6s7-15.5 15.6-15.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#favicon_svg__SVGID_2_)"
  })))));
}

export default __webpack_public_path__ + "static/media/favicon.23e600f5.svg";
export { SvgFavicon as ReactComponent };